import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { buttonVariants } from "@/components/ui/button";
import PublicPlanCards from "./PublicPlanCards";
import PublicShell from "./PublicShell";

export default function Pricing() {
  const { t } = useTranslation();

  return (
    <PublicShell>
      <main>
        <section className="px-6 py-20 text-center">
          <div className="mx-auto max-w-2xl space-y-4">
            <h1 className="text-4xl font-semibold tracking-tight sm:text-5xl">
              {t("public.pricing.title")}
            </h1>
          </div>
        </section>

        <section className="px-6 pb-20">
          <PublicPlanCards />
        </section>

        <section className="bg-primary px-6 py-16 text-center text-primary-foreground">
          <div className="mx-auto max-w-xl space-y-4">
            <h2 className="text-2xl font-semibold tracking-tight">
              {t("public.pricing.ctaTitle")}
            </h2>
            <p className="text-primary-foreground/80">
              {t("public.pricing.ctaSub")}
            </p>
            <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
              <Link
                to="/login"
                className={buttonVariants({
                  variant: "secondary",
                  className: "w-full sm:w-auto",
                })}
              >
                {t("public.pricing.getStarted")}
              </Link>
              <span
                className={buttonVariants({
                  variant: "outline",
                  className:
                    "w-full border-primary-foreground/40 text-primary-foreground hover:bg-primary-foreground/10 sm:w-auto",
                })}
              >
                {t("public.pricing.contactSales")}
              </span>
            </div>
          </div>
        </section>
      </main>
    </PublicShell>
  );
}
